import { render, staticRenderFns } from "./exam_flanker.vue?vue&type=template&id=23bce1f8&scoped=true&"
import script from "./exam_flanker.vue?vue&type=script&lang=js&"
export * from "./exam_flanker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bce1f8",
  null
  
)

export default component.exports